import lazyLoading from '../../utils/lazyLoading'

export default {
  hidden: false,
  createroutes: true,
  meta: {
    label: 'Financieel',
    permission: '',
    icon: 'mdi-bank',
    expanded: false
  },
  children: [
    {
      name: 'admin_finance_products',
      path: '/admin/finance/products/',
      component: lazyLoading('admin/finance/Products'),
      meta: {
        label: 'Producten',
        permission: 'ADFIPRV',
        link: 'admin/finance/Products.vue'
      }
    },
    {
      name: 'admin_finance_export',
      path: '/admin/finance/export/',
      component: lazyLoading('admin/finance/Export'),
      meta: {
        label: 'Export',
        permission: 'ADFIEXP',
        link: 'admin/finance/Export.vue'
      }
    }
  ]
}



// WEBPACK FOOTER //
// ./src/store/menu/finance.js